import { ICellEditorParams } from "ag-grid-community";
import { useEffect, useRef, useState } from "react";

export default function PayablesEditor(props: ICellEditorParams) {
  const { data, api, context } = props;

  const [payables, setPayables] = useState(data?.payables?.column_value || "");
  const [payablesStatus, setPayablesStatus] = useState(
    data?.payables_status?.column_value || ""
  );

  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleBlur = (e: FocusEvent) => {
    if (!wrapperRef.current) return;
    // if the new focused element is inside our editor, don't save yet
    if (wrapperRef.current.contains(e.relatedTarget as Node)) return;
    saveChanges();
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      saveChanges();
    }
  };

  useEffect(() => {
    const node = wrapperRef.current;
    node?.addEventListener("keydown", handleKeyDown);
    node?.addEventListener("focusout", handleBlur);
    return () => {
      node?.removeEventListener("keydown", handleKeyDown);
      node?.removeEventListener("focusout", handleBlur);
    };
  }, [payables, payablesStatus]);

  const saveChanges = () => {
    data.payables.column_value = payables;
    data.payables_status.column_value = payablesStatus;
    api.applyTransaction({ update: [data] }); // update row

    context?.handleSave?.();
  };

  return (
    <div className="flex" ref={wrapperRef}>
      <input
        type="number"
        placeholder="Enter"
        name="payables"
        value={payables}
        onChange={(e) => setPayables(e.target.value)}
        className="w-full pl-2 outline-none"
        autoFocus
      />
      <select
        value={payablesStatus}
        onChange={(e) => setPayablesStatus(e.target.value)}
        className="w-full outline-none"
      >
        <option value="" disabled className="text-gray-400">
          Select status
        </option>
        <option value="Pending">Pending</option>
        <option value="Paid">Paid</option>
      </select>
    </div>
  );
}
